import {Component, Injectable, Input, OnDestroy, OnInit, ElementRef} from '@angular/core';

import {NxDatepickerIntl} from '@aposin/ng-aquila/datefield';
import {Subscription} from 'rxjs';
import {GenericFieldDirective} from '../../directives/generic-field/generic-field.directive';
import {FormDate} from '../../interfaces/forms/form-element';
import {FieldService} from '../../services/field/field.service';
import moment from 'moment';
import {NgModel, ValidationErrors} from '@angular/forms';
type DatePickerKeys = 'minDate' | 'maxDate' | 'startDate';
@Injectable()
export class MyIntl extends NxDatepickerIntl {
  override switchToMonthViewLabel = "Scegli l'anno";
  override switchToMultiYearViewLabel = 'Scegli una data';
}

@Component({
    selector: 'app-date-form',
    templateUrl: './date-form.component.html',
    styleUrls: ['./date-form.component.scss'],
    providers: [{ provide: NxDatepickerIntl, useClass: MyIntl }],
    standalone: false
})
export class DateFormComponent extends GenericFieldDirective implements OnInit, OnDestroy {
  @Input() override field!: FormDate;

  datepickerDate!: NgModel | moment.Moment | null;
  newDate: moment.Moment | null = null;

  dateSubscriber: Subscription[] = [];

  fieldValidation: Record<'minDate' | 'maxDate', 'isBefore' | 'isAfter'> = {
    minDate: 'isBefore',
    maxDate: 'isAfter',
  };

  fieldToCheck: DatePickerKeys[] = ['minDate', 'maxDate', 'startDate'];
  fieldsChecked: Record<DatePickerKeys, moment.Moment | null> = {
    minDate: null,
    maxDate: null,
    startDate: null,
  };

  constructor(
    protected override fieldService: FieldService,
    protected override element: ElementRef,
  ) {
    super(fieldService, element);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const field = this.formGroup.get(this.field.name);

    field?.valueChanges.subscribe((res) => {
      this.datepickerDate = this.newDate = null;
      //      if (field.valid) {
      this.newDate = moment(res, (this.field.mask?.masks as string) ?? this.field.format);
      this.datepickerDate = this.newDate;
      const error = this.checkDate(this.datepickerDate);
      if (error && Object.keys(error).length > 0) {
        field.setErrors(error);
      }
      //      }
    });

    this.checkFields(this.fieldToCheck);
  }

  checkDate(date: moment.Moment): ValidationErrors | null {
    const errors = this.fieldToCheck.reduce((obj, el: DatePickerKeys) => {
      if (this.field.datePicker && this.field.datePicker[el]) {
        const validationMethod = this.fieldValidation[el as 'minDate' | 'maxDate'];
        if (validationMethod && date[validationMethod](this.field.datePicker[el])) {
          obj[el] = true;
        }
      }
      return obj;
    }, {} as ValidationErrors);

    return Object.keys(errors).length > 0 ? errors : null;
  }

  onDateChange(event: any) {
    const name = this.formGroup.get(this.field.name);
    if (name) {
      name.markAsDirty();
      name.patchValue(this.field.mask ? event.format(this.field.mask?.masks || this.field.format) : event, {
        emitEvent: true,
      });
    }
  }

  checkFields(fields: DatePickerKeys[]) {
    fields.forEach((el) => {
      if (typeof el === 'string') {
        const dateEl = this.formGroup.get(el);
        if (dateEl) {
          this.dateSubscriber.push(
            dateEl.valueChanges.subscribe((res) => {
              this.fieldsChecked[el] = res || null;
            }),
          );
        }
      }
    });
  }

  onDatepickerClosed() {
    const control = this.formGroup.controls[this.field.name];
    if (control.untouched && control.value) control.markAsTouched();
    return;
  }

  defFilter(_: Date | moment.Moment | null) {
    return true;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.dateSubscriber.forEach((el) => el.unsubscribe());
  }
}
